import React from 'react';

const ProgressBar = ({
    className = '',
    value = 0,
    text = '',
    nums = false,
    max = 100,
    readonly = true,
    stroke = 4,
}) => {
    if (!readonly) {
        return null;
    }

    const safeMax = Math.max(Number(max) || 0, 1);
    const safeValue = Math.min(
        Math.max(Number(value) || 0, 0),
        safeMax
    );

    const progress = (safeValue / safeMax) * 100;

    const height = Math.max(stroke / 4, 0.5);

    return (
        <div
            className={`
relative
w-full
overflow-hidden
rounded-full
bg-gray-100
border
border-gray-200
${className}
`}
            style={{
                height: `${height}rem`,
            }}
            dir="rtl"
        >
            {/* Progress */}
            <div
                className="
                    absolute
                    top-0
                    right-0
                    h-full
                    rounded-full
                    bg-blue-600
                    transition-all
                    duration-500
                    ease-out
                "
                style={{
                    width: `${progress}%`,
                }}
            />

            {nums && (
                <>
                    {/* Current value */}
                    <span
                        className="
                            absolute
                            inset-y-0
                            right-3
                            z-10
                            flex
                            items-center
                            text-xs
                            font-bold
                            text-white
                            whitespace-nowrap
                        "
                    >
                        {safeValue}
                        {text && ` ${text}`}
                    </span>

                    {/* Maximum */}
                    {progress < 50 && (
                        <span
                            className="
                                absolute
                                inset-y-0
                                left-3
                                z-10
                                flex
                                items-center
                                text-xs
                                font-semibold
                                text-gray-600
                                whitespace-nowrap
                            "
                        >
                            {safeMax}
                            {text && ` ${text}`}
                        </span>
                    )}
                </>
            )}
        </div>
    );
};

export default ProgressBar;
